$(document).ready(function (){
    let types = [];
    let capacities = [];

    $('.toggle-hosting').on('click', function(event) {
        let id = event.target.id
        let type = $(this).data('toggle')

        type === 'capacities' ? addInArray(capacities, id) : addInArray(types, id);

        ajaxRequest();
    });

    function addInArray (array, item) {
        !array.includes(item) ? array.push(item) : array.splice(array.indexOf(item), 1);
    }

    function ajaxRequest() {
        $('.activities__items').toggleClass('loading');
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'filter_hostings',
                types: types,
                capacities: capacities
            },
            success: function(res) {
                $('.activities__items').html(res);
                $('.activities__items').toggleClass('loading');
            }
        })
    }
});
